import type { App } from "vue"
import type { ModuleDefinition, ModuleOptions } from "@core/types/module"
import { registerValidator } from "./helpers/validators/registry"
import type { ValidatorWithContext } from "./helpers/validators/registry"
import * as validators from "./helpers/validators/index"

const dataModule: ModuleDefinition = {
    name: "data",

    install(_app: App, _options: ModuleOptions): void {
        // Enregistrement automatique de tous les validators
        for (const [exportName, exportValue] of Object.entries(validators)) {
            if (
                exportValue &&
                typeof exportValue === "object" &&
                "validator" in exportValue
            ) {
                const validatorId = exportName
                    .replace(/([A-Z])/g, "_$1")
                    .toLowerCase()
                    .replace(/^_/, "")

                registerValidator(
                    validatorId,
                    exportValue as ValidatorWithContext
                )
            }
        }

        console.log("[data] Validators enregistrés")
    },
}

export default dataModule
